import { useState } from 'react';
import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import SectionHeading from '@/components/base/SectionHeading';
import { catalog } from '@/mocks/catalog';

const TABS = [
  { key: 'movie', label: '最新电影' },
  { key: 'tv', label: '最新电视剧' },
] as const;

export default function LatestSection() {
  const [tab, setTab] = useState<'movie' | 'tv'>('movie');

  const list = catalog
    .filter((item) => item.type === tab)
    .sort((a, b) => b.year - a.year)
    .slice(0, 6);

  return (
    <section aria-label="最新影视">
      <SectionHeading
        title="最新影视"
        subtitle="按上映年份更新的院线与剧集内容"
        icon="ri-time-line"
      />

      <div className="mb-5 inline-flex items-center gap-1 p-1 rounded-full bg-background-200" role="tablist">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={tab === item.key}
            onClick={() => setTab(item.key)}
            className={`px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap ${
              tab === item.key
                ? 'bg-background-50 text-primary-700 font-semibold'
                : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
        {list.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>

      <Link
        to={`/category/${tab}`}
        className="mt-5 flex items-center justify-center gap-2 w-full py-3 rounded-lg border border-background-300 text-sm text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors"
      >
        查看全部{tab === 'movie' ? '电影' : '电视剧'}
        <i className="ri-arrow-right-line"></i>
      </Link>
    </section>
  );
}